var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoEdicion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215.296,
    height: 250,
    viewBox: "0 0 215.296 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32379",
    "data-name": "Rect\\xE1ngulo 32379",
    width: 215.296,
    height: 250,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32239",
    "data-name": "Rect\\xE1ngulo 32239",
    width: 191.494,
    height: 155.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32238",
    "data-name": "Rect\\xE1ngulo 32238",
    width: 191.493,
    height: 155.923,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_27424",
    x: 4.337,
    y: 43.596,
    width: 204.679,
    height: 169.108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27425",
    "data-name": "Trazado 27425",
    d: "M56.285,185.44a6.419,6.419,0,0,0-6.419,6.419V232.9h186.68V191.859a6.419,6.419,0,0,0-6.419-6.419Z",
    transform: "translate(-49.866 -185.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32250",
    "data-name": "Rect\\xE1ngulo 32250",
    width: 67.712,
    height: 67.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32243",
    "data-name": "Rect\\xE1ngulo 32243",
    width: 33.856,
    height: 33.856,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32288",
    "data-name": "Rect\\xE1ngulo 32288",
    width: 33.856,
    height: 34.141,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32300",
    "data-name": "Rect\\xE1ngulo 32300",
    width: 33.856,
    height: 33.888,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32305",
    "data-name": "Rect\\xE1ngulo 32305",
    width: 33.856,
    height: 34.31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27426",
    "data-name": "Trazado 27426",
    d: "M49.866,571.879v41.337a6.421,6.421,0,0,0,5.033,6.269H231.512a6.421,6.421,0,0,0,5.033-6.269V571.879Z",
    transform: "translate(-49.866 -571.879)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32372",
    "data-name": "Rect\\xE1ngulo 32372",
    width: 33.856,
    height: 34.311,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58158",
    "data-name": "Grupo 58158",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57951",
    "data-name": "Grupo 57951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_57950",
    "data-name": "Enmascarar grupo 57950",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57949",
    "data-name": "Grupo 57949",
    transform: "translate(13.069 49.328)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57948",
    "data-name": "Grupo 57948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57947",
    "data-name": "Grupo 57947",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57946",
    "data-name": "Grupo 57946",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57945",
    "data-name": "Grupo 57945",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_32237",
    "data-name": "Rect\\xE1ngulo 32237",
    width: 191.493,
    height: 155.923,
    xlinkHref: "data:image/png;base64,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"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trazado_27424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27424-2",
    "data-name": "Trazado 27424",
    d: "M230.128,336.548H56.286a6.419,6.419,0,0,1-6.419-6.419V191.859a6.419,6.419,0,0,1,6.419-6.419H230.128a6.419,6.419,0,0,1,6.419,6.419V330.13a6.419,6.419,0,0,1-6.419,6.419",
    transform: "translate(-36.53 -135.84)",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58053",
    "data-name": "Grupo 58053",
    transform: "translate(13.337 49.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58052",
    "data-name": "Grupo 58052",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57966",
    "data-name": "Grupo 57966",
    transform: "translate(60.437 -32.953)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57965",
    "data-name": "Grupo 57965",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57964",
    "data-name": "Grupo 57964",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57963",
    "data-name": "Grupo 57963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57962",
    "data-name": "Grupo 57962",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57956",
    "data-name": "Grupo 57956",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57955",
    "data-name": "Grupo 57955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57954",
    "data-name": "Grupo 57954",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57953",
    "data-name": "Grupo 57953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57952",
    "data-name": "Grupo 57952",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32241",
    "data-name": "Rect\\xE1ngulo 32241",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32244",
    "data-name": "Rect\\xE1ngulo 32244",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32245",
    "data-name": "Rect\\xE1ngulo 32245",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57961",
    "data-name": "Grupo 57961",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57960",
    "data-name": "Grupo 57960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57959",
    "data-name": "Grupo 57959",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57958",
    "data-name": "Grupo 57958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57957",
    "data-name": "Grupo 57957",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32246",
    "data-name": "Rect\\xE1ngulo 32246",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57981",
    "data-name": "Grupo 57981",
    transform: "translate(10.224 -32.953)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57980",
    "data-name": "Grupo 57980",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57979",
    "data-name": "Grupo 57979",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57978",
    "data-name": "Grupo 57978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57977",
    "data-name": "Grupo 57977",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57971",
    "data-name": "Grupo 57971",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57970",
    "data-name": "Grupo 57970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57969",
    "data-name": "Grupo 57969",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57968",
    "data-name": "Grupo 57968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57967",
    "data-name": "Grupo 57967",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32251",
    "data-name": "Rect\\xE1ngulo 32251",
    width: 23.94,
    height: 23.94,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 16.928)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32254",
    "data-name": "Rect\\xE1ngulo 32254",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32255",
    "data-name": "Rect\\xE1ngulo 32255",
    width: 23.94,
    height: 23.94,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 33.856)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57976",
    "data-name": "Grupo 57976",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57975",
    "data-name": "Grupo 57975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57974",
    "data-name": "Grupo 57974",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57973",
    "data-name": "Grupo 57973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57972",
    "data-name": "Grupo 57972",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32256",
    "data-name": "Rect\\xE1ngulo 32256",
    width: 23.94,
    height: 23.94,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 16.928)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57996",
    "data-name": "Grupo 57996",
    transform: "translate(-6.989 -32.668)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57995",
    "data-name": "Grupo 57995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57994",
    "data-name": "Grupo 57994",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57993",
    "data-name": "Grupo 57993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57992",
    "data-name": "Grupo 57992",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57986",
    "data-name": "Grupo 57986",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57985",
    "data-name": "Grupo 57985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57984",
    "data-name": "Grupo 57984",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57983",
    "data-name": "Grupo 57983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57982",
    "data-name": "Grupo 57982",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32261",
    "data-name": "Rect\\xE1ngulo 32261",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32264",
    "data-name": "Rect\\xE1ngulo 32264",
    width: 23.94,
    height: 23.94,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 33.856, 33.856)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32265",
    "data-name": "Rect\\xE1ngulo 32265",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57991",
    "data-name": "Grupo 57991",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57990",
    "data-name": "Grupo 57990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57989",
    "data-name": "Grupo 57989",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57988",
    "data-name": "Grupo 57988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57987",
    "data-name": "Grupo 57987",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32266",
    "data-name": "Rect\\xE1ngulo 32266",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58011",
    "data-name": "Grupo 58011",
    transform: "translate(127.244 -32.953)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58010",
    "data-name": "Grupo 58010",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58009",
    "data-name": "Grupo 58009",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58008",
    "data-name": "Grupo 58008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58007",
    "data-name": "Grupo 58007",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58001",
    "data-name": "Grupo 58001",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58000",
    "data-name": "Grupo 58000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57999",
    "data-name": "Grupo 57999",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57998",
    "data-name": "Grupo 57998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57997",
    "data-name": "Grupo 57997",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32271",
    "data-name": "Rect\\xE1ngulo 32271",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32274",
    "data-name": "Rect\\xE1ngulo 32274",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32275",
    "data-name": "Rect\\xE1ngulo 32275",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58006",
    "data-name": "Grupo 58006",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58005",
    "data-name": "Grupo 58005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58004",
    "data-name": "Grupo 58004",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58003",
    "data-name": "Grupo 58003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58002",
    "data-name": "Grupo 58002",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32276",
    "data-name": "Rect\\xE1ngulo 32276",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58026",
    "data-name": "Grupo 58026",
    transform: "translate(111.221 -32.953)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58025",
    "data-name": "Grupo 58025",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58024",
    "data-name": "Grupo 58024",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58023",
    "data-name": "Grupo 58023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58022",
    "data-name": "Grupo 58022",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58016",
    "data-name": "Grupo 58016",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58015",
    "data-name": "Grupo 58015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58014",
    "data-name": "Grupo 58014",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58013",
    "data-name": "Grupo 58013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58012",
    "data-name": "Grupo 58012",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32281",
    "data-name": "Rect\\xE1ngulo 32281",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32284",
    "data-name": "Rect\\xE1ngulo 32284",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32285",
    "data-name": "Rect\\xE1ngulo 32285",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58021",
    "data-name": "Grupo 58021",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58020",
    "data-name": "Grupo 58020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58019",
    "data-name": "Grupo 58019",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58018",
    "data-name": "Grupo 58018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58017",
    "data-name": "Grupo 58017",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32286",
    "data-name": "Rect\\xE1ngulo 32286",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 17.213) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58036",
    "data-name": "Grupo 58036",
    transform: "translate(60.437 -49.596)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58035",
    "data-name": "Grupo 58035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58034",
    "data-name": "Grupo 58034",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58033",
    "data-name": "Grupo 58033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58032",
    "data-name": "Grupo 58032",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58031",
    "data-name": "Grupo 58031",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58030",
    "data-name": "Grupo 58030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58029",
    "data-name": "Grupo 58029",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58028",
    "data-name": "Grupo 58028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58027",
    "data-name": "Grupo 58027",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32291",
    "data-name": "Rect\\xE1ngulo 32291",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32294",
    "data-name": "Rect\\xE1ngulo 32294",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32295",
    "data-name": "Rect\\xE1ngulo 32295",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 34.123) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58051",
    "data-name": "Grupo 58051",
    transform: "translate(44.079 -32.953)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58050",
    "data-name": "Grupo 58050",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58049",
    "data-name": "Grupo 58049",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58048",
    "data-name": "Grupo 58048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58047",
    "data-name": "Grupo 58047",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58041",
    "data-name": "Grupo 58041",
    transform: "translate(16.928 33.823)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58040",
    "data-name": "Grupo 58040",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58039",
    "data-name": "Grupo 58039",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58038",
    "data-name": "Grupo 58038",
    transform: "translate(0 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58037",
    "data-name": "Grupo 58037",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32298",
    "data-name": "Rect\\xE1ngulo 32298",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.896) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32301",
    "data-name": "Rect\\xE1ngulo 32301",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32302",
    "data-name": "Rect\\xE1ngulo 32302",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.365) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58046",
    "data-name": "Grupo 58046",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58045",
    "data-name": "Grupo 58045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58044",
    "data-name": "Grupo 58044",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58043",
    "data-name": "Grupo 58043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58042",
    "data-name": "Grupo 58042",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32303",
    "data-name": "Rect\\xE1ngulo 32303",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 17.383) rotate(-45)",
    fill: "#9159cb"
  })))))))))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58155",
    "data-name": "Grupo 58155",
    transform: "translate(13.337 152.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58154",
    "data-name": "Grupo 58154",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58068",
    "data-name": "Grupo 58068",
    transform: "translate(60.474 12.697)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58067",
    "data-name": "Grupo 58067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58066",
    "data-name": "Grupo 58066",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58065",
    "data-name": "Grupo 58065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58064",
    "data-name": "Grupo 58064",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58058",
    "data-name": "Grupo 58058",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58057",
    "data-name": "Grupo 58057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58056",
    "data-name": "Grupo 58056",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58055",
    "data-name": "Grupo 58055",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58054",
    "data-name": "Grupo 58054",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32308",
    "data-name": "Rect\\xE1ngulo 32308",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32311",
    "data-name": "Rect\\xE1ngulo 32311",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32312",
    "data-name": "Rect\\xE1ngulo 32312",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58063",
    "data-name": "Grupo 58063",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58062",
    "data-name": "Grupo 58062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58061",
    "data-name": "Grupo 58061",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58060",
    "data-name": "Grupo 58060",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58059",
    "data-name": "Grupo 58059",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32313",
    "data-name": "Rect\\xE1ngulo 32313",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58083",
    "data-name": "Grupo 58083",
    transform: "translate(110.688 12.697)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58082",
    "data-name": "Grupo 58082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58081",
    "data-name": "Grupo 58081",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58080",
    "data-name": "Grupo 58080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58079",
    "data-name": "Grupo 58079",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58073",
    "data-name": "Grupo 58073",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58072",
    "data-name": "Grupo 58072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58071",
    "data-name": "Grupo 58071",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58070",
    "data-name": "Grupo 58070",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58069",
    "data-name": "Grupo 58069",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32318",
    "data-name": "Rect\\xE1ngulo 32318",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32321",
    "data-name": "Rect\\xE1ngulo 32321",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32322",
    "data-name": "Rect\\xE1ngulo 32322",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58078",
    "data-name": "Grupo 58078",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58077",
    "data-name": "Grupo 58077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58076",
    "data-name": "Grupo 58076",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58075",
    "data-name": "Grupo 58075",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58074",
    "data-name": "Grupo 58074",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32323",
    "data-name": "Rect\\xE1ngulo 32323",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58098",
    "data-name": "Grupo 58098",
    transform: "translate(127.901 12.412)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58097",
    "data-name": "Grupo 58097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58096",
    "data-name": "Grupo 58096",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58095",
    "data-name": "Grupo 58095",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58094",
    "data-name": "Grupo 58094",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58088",
    "data-name": "Grupo 58088",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58087",
    "data-name": "Grupo 58087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58086",
    "data-name": "Grupo 58086",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58085",
    "data-name": "Grupo 58085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58084",
    "data-name": "Grupo 58084",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32328",
    "data-name": "Rect\\xE1ngulo 32328",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32331",
    "data-name": "Rect\\xE1ngulo 32331",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32332",
    "data-name": "Rect\\xE1ngulo 32332",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58093",
    "data-name": "Grupo 58093",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58092",
    "data-name": "Grupo 58092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58091",
    "data-name": "Grupo 58091",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58090",
    "data-name": "Grupo 58090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58089",
    "data-name": "Grupo 58089",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32333",
    "data-name": "Rect\\xE1ngulo 32333",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58113",
    "data-name": "Grupo 58113",
    transform: "translate(-6.332 12.697)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58112",
    "data-name": "Grupo 58112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58111",
    "data-name": "Grupo 58111",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58110",
    "data-name": "Grupo 58110",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58109",
    "data-name": "Grupo 58109",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58103",
    "data-name": "Grupo 58103",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58102",
    "data-name": "Grupo 58102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58101",
    "data-name": "Grupo 58101",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58100",
    "data-name": "Grupo 58100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58099",
    "data-name": "Grupo 58099",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32338",
    "data-name": "Rect\\xE1ngulo 32338",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32341",
    "data-name": "Rect\\xE1ngulo 32341",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32342",
    "data-name": "Rect\\xE1ngulo 32342",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58108",
    "data-name": "Grupo 58108",
    transform: "translate(16.928 33.856)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58107",
    "data-name": "Grupo 58107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58106",
    "data-name": "Grupo 58106",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58105",
    "data-name": "Grupo 58105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58104",
    "data-name": "Grupo 58104",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32343",
    "data-name": "Rect\\xE1ngulo 32343",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58128",
    "data-name": "Grupo 58128",
    transform: "translate(9.69 12.697)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58127",
    "data-name": "Grupo 58127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58126",
    "data-name": "Grupo 58126",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58125",
    "data-name": "Grupo 58125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58124",
    "data-name": "Grupo 58124",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58118",
    "data-name": "Grupo 58118",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58117",
    "data-name": "Grupo 58117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58116",
    "data-name": "Grupo 58116",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58115",
    "data-name": "Grupo 58115",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58114",
    "data-name": "Grupo 58114",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32348",
    "data-name": "Rect\\xE1ngulo 32348",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32351",
    "data-name": "Rect\\xE1ngulo 32351",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32352",
    "data-name": "Rect\\xE1ngulo 32352",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58123",
    "data-name": "Grupo 58123",
    transform: "translate(16.928 33.571)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58122",
    "data-name": "Grupo 58122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58121",
    "data-name": "Grupo 58121",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58120",
    "data-name": "Grupo 58120",
    transform: "translate(0 0.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58119",
    "data-name": "Grupo 58119",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32353",
    "data-name": "Rect\\xE1ngulo 32353",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.643) rotate(-45)",
    fill: "#9159cb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58138",
    "data-name": "Grupo 58138",
    transform: "translate(60.474 29.34)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58137",
    "data-name": "Grupo 58137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58136",
    "data-name": "Grupo 58136",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58135",
    "data-name": "Grupo 58135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58134",
    "data-name": "Grupo 58134",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58133",
    "data-name": "Grupo 58133",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58132",
    "data-name": "Grupo 58132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58131",
    "data-name": "Grupo 58131",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58130",
    "data-name": "Grupo 58130",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58129",
    "data-name": "Grupo 58129",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32358",
    "data-name": "Rect\\xE1ngulo 32358",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.928) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32361",
    "data-name": "Rect\\xE1ngulo 32361",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32362",
    "data-name": "Rect\\xE1ngulo 32362",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 33.588) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58153",
    "data-name": "Grupo 58153",
    transform: "translate(76.832 12.697)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58152",
    "data-name": "Grupo 58152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58151",
    "data-name": "Grupo 58151",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58150",
    "data-name": "Grupo 58150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58149",
    "data-name": "Grupo 58149",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58143",
    "data-name": "Grupo 58143",
    transform: "translate(16.928)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58142",
    "data-name": "Grupo 58142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58141",
    "data-name": "Grupo 58141",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58140",
    "data-name": "Grupo 58140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58139",
    "data-name": "Grupo 58139",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32365",
    "data-name": "Rect\\xE1ngulo 32365",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.96) rotate(-45)",
    fill: "#9159cb"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32368",
    "data-name": "Rect\\xE1ngulo 32368",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 33.856) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32369",
    "data-name": "Rect\\xE1ngulo 32369",
    width: 23.94,
    height: 23.94,
    transform: "translate(33.856 34.346) rotate(-45)",
    fill: "#9159cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58148",
    "data-name": "Grupo 58148",
    transform: "translate(16.928 33.401)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58147",
    "data-name": "Grupo 58147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58146",
    "data-name": "Grupo 58146",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58145",
    "data-name": "Grupo 58145",
    transform: "translate(0 0.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58144",
    "data-name": "Grupo 58144",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32370",
    "data-name": "Rect\\xE1ngulo 32370",
    width: 23.94,
    height: 23.94,
    transform: "translate(0 16.473) rotate(-45)",
    fill: "#9159cb"
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoEdicion);
export default __webpack_public_path__ + "static/media/fondo_edicion.e62719c6819608cc03db65a4248629dc.svg";
export { ForwardRef as ReactComponent };